<template>
  <v-card elevation="5" outlined shaped>
    <v-dialog v-model="carreraModal" max-width="600" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>CARRERA</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersCarrera"
                  :items="datosCarrera"
                  @click:row="($event, {item})=>seleccionarCarrera(item)"
                  :items-per-page="5"
                  class="elevation-1"
                  id="tableId"
                  hide-default-footer disable-pagination
                >
                  <!--template #[`item.actions`]="{ item }">
                    <v-icon
                      color="blue"
                      small
                      class="mr-2"
                      @click="seleccionarCarrera(item)"
                    >
                      mdi-check-circle
                    </v-icon>
                  </template-->
                </v-data-table>
              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="#EE680B"
                  @click="closeCarrera"
                  style="float: right"
                  title="SALIR"
                >
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="gestionModal" max-width="400" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>GESTION</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersGestion"
                  :items="datosGestion"
                   @click:row="($event, {item})=>seleccionarGestion(item)"
                  :items-per-page="5"
                  class="elevation-1"
                  id="tableId"
                  hide-default-footer disable-pagination
                >
                  
                </v-data-table>
              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="#EE680B"
                  @click="closeGestion"
                  style="float: right"
                  title="SALIR"
                >
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="horarioModal" max-width="1450" class="text-center">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <header>
            <br />
            <div
              id="logo"
              style="float: left; margin-left: 2%; margin-right: 2%"
            >
              <img
                src="data:image/png;base64,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"
              />
            </div>
          </header>
          <span>
            <h5>
              &nbsp;&nbsp;&nbsp;ESTUDIANTE: &nbsp;{{ nombres }} {{ paterno }}
              {{ materno }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {{ carrera }} &nbsp; {{ gestion }}
            </h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersFranjaHoraria"
                  :items="datosFranjaHoraria"
                  class="elevation-1"
                  id="tableId"
                >
                  <template #[`item.lu`]="{ item }">
                    <p
                      v-if="item.lu != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.lu"
                    ></p>
                    <p
                      v-if="item.lu == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.lu"
                    ></p>
                  </template>
                  <template #[`item.ma`]="{ item }">
                    <p
                      v-if="item.ma != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.ma"
                    ></p>
                    <p
                      v-if="item.ma == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.ma"
                    ></p>
                  </template>
                  <template #[`item.mi`]="{ item }">
                    <p
                      v-if="item.mi != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.mi"
                    ></p>
                    <p
                      v-if="item.mi == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.mi"
                    ></p>
                  </template>
                  <template #[`item.ju`]="{ item }">
                    <p
                      v-if="item.ju != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.ju"
                    ></p>
                    <p
                      v-if="item.ju == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.ju"
                    ></p>
                  </template>
                  <template #[`item.vi`]="{ item }">
                    <p
                      v-if="item.vi != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.vi"
                    ></p>
                    <p
                      v-if="item.vi == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.vi"
                    ></p>
                  </template>
                  <template #[`item.sa`]="{ item }">
                    <p
                      v-if="item.sa != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.sa"
                    ></p>
                    <p
                      v-if="item.sa == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.sa"
                    ></p>
                  </template>
                  <template #[`item.do`]="{ item }">
                    <p
                      v-if="item.do != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.do"
                    ></p>
                    <p
                      v-if="item.do == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.do"
                    ></p>
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="seleccionarHorario(item)"
                    >
                      mdi-check-circle
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>

              <v-col cols="12" md="8"> </v-col>
              <v-col cols="12" md="4">
                <v-toolbar dense shaped color="#002245">
                  <v-toolbar-title style="color: #ffffff">
                    <h6>OPCIONES</h6>
                  </v-toolbar-title>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="#EE680B"
                    @click="imprimirHorario()"
                    style="float: left"
                    title="IMPRIMIR HORARIO"
                  >
                    <v-icon dark> mdi-printer-outline </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="#EE680B"
                    @click="closeHorario"
                    style="float: left"
                    title="SALIR"
                  >
                    <v-icon dark> mdi-close-circle-outline </v-icon>
                  </v-btn>
                </v-toolbar>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="500"
      filename="horario"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      ref="html2Pdf"
      useCORS="true"
      pdf-content-width="100%"
    >
      <section slot="pdf-content">
        <v-card-title>
          <header>
            <br />
            <div
              id="logo"
              style="float: left; margin-left: 2%; margin-right: 2%"
            >
              <img
                src="data:image/png;base64,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"
              />
            </div>
            <br />
            <br />
          </header>
          <span>
            <h6>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ESTUDIANTE: &nbsp;{{
                nombres
              }}
              {{ paterno }} {{ materno }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {{ carrera }} &nbsp; {{ gestion }}
            </h6>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                 
                  :headers="headersFranjaHoraria"
                  :items="datosFranjaHoraria"
                  class="elevation-1"
                  id="tableId"
                  hide-default-footer
                  disable-pagination
                >
                  <template #[`item.lu`]="{ item }">
                    <p
                      v-if="item.lu != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.lu"
                    ></p>
                    <p
                      v-if="item.lu == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.lu"
                    ></p>
                  </template>
                  <template #[`item.ma`]="{ item }">
                    <p
                      v-if="item.ma != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.ma"
                    ></p>
                    <p
                      v-if="item.ma == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.ma"
                    ></p>
                  </template>
                  <template #[`item.mi`]="{ item }">
                    <p
                      v-if="item.mi != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.mi"
                    ></p>
                    <p
                      v-if="item.mi == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.mi"
                    ></p>
                  </template>
                  <template #[`item.ju`]="{ item }">
                    <p
                      v-if="item.ju != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.ju"
                    ></p>
                    <p
                      v-if="item.ju == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.ju"
                    ></p>
                  </template>
                  <template #[`item.vi`]="{ item }">
                    <p
                      v-if="item.vi != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.vi"
                    ></p>
                    <p
                      v-if="item.vi == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.vi"
                    ></p>
                  </template>
                  <template #[`item.sa`]="{ item }">
                    <p
                      v-if="item.sa != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.sa"
                    ></p>
                    <p
                      v-if="item.sa == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.sa"
                    ></p>
                  </template>
                  <template #[`item.do`]="{ item }">
                    <p
                      v-if="item.do != 'LIBRE'"
                      style="background-color: #ffcc80"
                      v-html="item.do"
                    ></p>
                    <p
                      v-if="item.do == 'LIBRE'"
                      style="background-color: #ffffff"
                      v-html="item.do"
                    ></p>
                  </template>
                  
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </section>
    </VueHtml2pdf>

    <div>
      <v-alert dense color="#EE680B" style="color: #ffffff">
        <h5>HORARIO DE CLASES</h5>
      </v-alert>
    </div>

    <v-container>
      <v-row>
       <v-col cols="12" md="12">
              
                 <v-btn 
             rounded
                   color="#002245"
                    class="ma-2 white--text"
                     @click="showCarrera()"
                    >
                  SELECCIONA TU  CARRERA
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-school-outline
              </v-icon>
           </v-btn>
            </v-col>
        <v-col cols="12" md="12 ">
          <v-text-field
            v-model="carrera"
            label="CARRERA"
            disabled
            required
          ></v-text-field>
        </v-col>

     <v-col cols="12" md="12">
               <v-btn 
             rounded
                   color="#EE680B"
                    class="ma-2 white--text"
                     @click="showGestion()"
                     
                    >
                  SELECCIONA TU  GESTION
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-calendar-clock-outline
              </v-icon>
           </v-btn>
            </v-col>
        <v-col cols="12" md="12">
          <v-text-field
            v-model="gestion"
            label="GESTION"
            disabled
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card elevation="5" outlined shaped>
      <v-row>
        <v-col cols="12">
          <v-col cols="12">
            <v-data-table
              :headers="headersFranjaHoraria"
              :items="datosFranjaHoraria"
              class="elevation-1"
              id="tableId"
              hide-default-footer
              disable-pagination
            >
              <template #[`item.lu`]="{ item }">
                <p
                  v-if="item.lu != 'LIBRE'"
                  style="background-color: #ffcc80"
                  v-html="item.lu"
                ></p>
                <p
                  v-if="item.lu == 'LIBRE'"
                  style="background-color: #ffffff"
                  v-html="item.lu"
                ></p>
              </template>
              <template #[`item.ma`]="{ item }">
                <p
                  v-if="item.ma != 'LIBRE'"
                  style="background-color: #ffcc80"
                  v-html="item.ma"
                ></p>
                <p
                  v-if="item.ma == 'LIBRE'"
                  style="background-color: #ffffff"
                  v-html="item.ma"
                ></p>
              </template>
              <template #[`item.mi`]="{ item }">
                <p
                  v-if="item.mi != 'LIBRE'"
                  style="background-color: #ffcc80"
                  v-html="item.mi"
                ></p>
                <p
                  v-if="item.mi == 'LIBRE'"
                  style="background-color: #ffffff"
                  v-html="item.mi"
                ></p>
              </template>
              <template #[`item.ju`]="{ item }">
                <p
                  v-if="item.ju != 'LIBRE'"
                  style="background-color: #ffcc80"
                  v-html="item.ju"
                ></p>
                <p
                  v-if="item.ju == 'LIBRE'"
                  style="background-color: #ffffff"
                  v-html="item.ju"
                ></p>
              </template>
              <template #[`item.vi`]="{ item }">
                <p
                  v-if="item.vi != 'LIBRE'"
                  style="background-color: #ffcc80"
                  v-html="item.vi"
                ></p>
                <p
                  v-if="item.vi == 'LIBRE'"
                  style="background-color: #ffffff"
                  v-html="item.vi"
                ></p>
              </template>
              <template #[`item.sa`]="{ item }">
                <p
                  v-if="item.sa != 'LIBRE'"
                  style="background-color: #ffcc80"
                  v-html="item.sa"
                ></p>
                <p
                  v-if="item.sa == 'LIBRE'"
                  style="background-color: #ffffff"
                  v-html="item.sa"
                ></p>
              </template>
              <template #[`item.do`]="{ item }">
                <p
                  v-if="item.do != 'LIBRE'"
                  style="background-color: #ffcc80"
                  v-html="item.do"
                ></p>
                <p
                  v-if="item.do == 'LIBRE'"
                  style="background-color: #ffffff"
                  v-html="item.do"
                ></p>
              </template>

              <template #[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="seleccionarHorario(item)">
                  mdi-check-circle
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-col>

       
        <v-col cols="12" md="12"> 
            <v-btn 
             rounded
                   color="#EE680B"
                    class="ma-2 white--text"
                     @click="imprimirHorario()"
                    >
                  DESCARGAR KARDEX
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-download-circle-outline
              </v-icon>
           </v-btn>

          </v-col>
      </v-row>
    </v-card>

    <div class="text-center">
      <v-snackbar
        v-model="snackbarOK"
        :timeout="timeout"
        top
        right
        shaped
        dense
        color="#EE680B"
        outlined
      >
        <strong>{{ mensajeSnackbar }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarOK = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>
    <div class="text-center">
      <v-snackbar
        v-model="snackbarError"
        :timeout="timeout"
        top
        right
        shaped
        dense
        color="#EE680B"
        outlined
      >
        <strong>{{ mensajeSnackbar }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>

    <div class="text-center">
      <v-snackbar
        v-model="snackbarError1"
        :timeout="timeout"
        top
        right
        shaped
        dense
        color="#EE680B"
        outlined
      >
        <strong>{{ mensajeSnackbarHorario }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError1 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>
    <div class="text-center">
      <v-snackbar
        v-model="snackbarError2"
        :timeout="timeout"
        top
        right
        shaped
        dense
        color="#EE680B"
        outlined
      >
        <strong>{{ mensajeSnackbarGrupoLleno }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError2 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>

      <v-snackbar
        v-model="snackbarError3"
        :timeout="timeout"
        top
        right
        shaped
        dense
        color="#EE680B"
        outlined
      >
        <strong>{{ mensajeSnackbarNivel }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError3 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>
  </v-card>
</template>
  <script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
export default {
  data() {
    return {
      fechaHoy: "",
      fechaEntrega: "",
      mat: "",
      pat: "",
      id_estudiante: "",
      unicodigo: "",
      num_documento: "",
      paterno: "",
      materno: "",
      nombres: "",
      nombreCompleto: "",
      datosCarrera: [],
      idPlanestudio: "",
      idCarrera: "",
      carrera: "",
      gestion: "",
      idGestion: "",
      datosOfertaMaterias: [],
      idMateria: "",
      detalleModal: 0,
      datosCantidadEstGrupo: [],
      datosGruposInscripcion: [],
      idTurno: "",
      datosTurno: [],
      turno: "",
      idGrupoDocente: "",
      idTipoModalidad: 1,
      modalidad: "",
      paralelo: "",
      capacidad: "",
      tipoGrupo: "",
      idNivel: "",
      idUsuario: 6,
      idPlanEconomico: "",
      yaInscrito: false,
      cantidadMaximaMaterias: 7,
      datosGruposPreInscripcion: [],
      idNota: "",
      minimoNivel: "",
      datosOfertaMateriasNivel: [],

      //tipo: "PRACTICO",
      gruposPracticosModal: 0,
      maxMateriasPreinscritas: 0,
      horarioModal: 0,
      datosHorario: [],
      idFranjaHoraria: "",
      idDia: "",
      cantAct: "",
      datosCantidadEspacio: [],
      datosHorariosGrupo: [],
      datosFranjaHoraria: [],
      //datosHorarioConvertido: [LUNES, MARTES, MIERCOLES, JUEVES, VIERNES, SABADO, DOMINGO],
      tienePractico: "FALSE",
      cantidadActualMaterias: 0,
      choqueHorario: 0,
      idGrupoPadre: "",
      esCompartido: "",
      kardexModal: 0,
      datosDocumentos: [],
      choquecant: 0,
      search: "",
      inpNum: "",
      id_docente: "",
      tipodocente: "",
      searchDocente: "",
      selectGenero: "",
      datosGenero: ["FEMENINO", "MASCULINO"],
      auxmat: "",
      auxpat: "",
      uniest: "",
      datosOfertaCorregido: [],
      datosCantMateriasEst: [],
      datosEstudiante: [],
      datosGestion: [],
      datosKardex: [],
      datosGruposInscripcionPracticos: [],
      est: "",
      elModal: 0,
      carreraModal: 0,
      gestionModal: 0,
      turnoModal: 0,
      horarioModal1: 0,
      documentosModal: 0,

      itencant: 0,
      doble: 0,
      itemcantidadModal: 0,
      deleteDialog: 0,
      oldNum: "",
      iditemdet: "",
      iditemdet1: "",
      totaldet: "",
      idtrans: "",
      busest: "",
      idcategoriaest: "",
      categoriaest: "",
      tiponacional: "",
      paisest: "",

      snackbarOK: false,
      mensajeSnackbar: "",
      mensajeSnackbarGrupoLleno: "GRUPO LLENO",
      mensajeSnackbarNivel: "AÚN TIENE MATERIAS DE NIVEL INFERIOR",
      mensajeSnackbarHorario: "CHOQUE DE HORARIO",
      mensajeSnackbarCantidadMaximaMaterias:
        "CANTIDAD MAXIMA DE MATERIAS TOMADAS",
      snackbarError: false,
      snackbarError1: false,
      snackbarError2: false,
      snackbarError3: false,
      mensajeError: "",

      timeout: 2000,

      alert: { show: false, message: "" },
      alertdocumento: { show: false, message: "" },

      headersTurno: [
        { text: "TURNO", value: "turno", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersHorario: [
        { text: "HORA", value: "hr", sortable: true },
        { text: "LUNES", value: "docaumat", sortable: true },
        { text: "MARTES", value: "docaumat", sortable: true },
        { text: "MIERCOLES", value: "docaumat", sortable: true },
        { text: "JUEVES", value: "docaumat", sortable: true },
        { text: "VIERNES", value: "docaumat", sortable: true },
        { text: "SABADO", value: "docaumat", sortable: true },
        // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersDocumentos: [
        { text: "DOCUMENTO", value: "documento", sortable: true },
        { text: "FECHA", value: "fpl", sortable: true },
        { text: "ESTADO", value: "estado", sortable: true },
        // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersFranjaHoraria: [
        { text: "HORA", value: "hr", sortable: false },
        { text: "LUNES", value: "lu", sortable: false },
        { text: "MARTES", value: "ma", sortable: false },
        { text: "MIERCOLES", value: "mi", sortable: false },
        { text: "JUEVES", value: "ju", sortable: false },
        { text: "VIERNES", value: "vi", sortable: false },
        { text: "SABADO", value: "sa", sortable: false },
        { text: "DOMINGO", value: "do", sortable: false },
      ],
      headersCarrera: [
        { text: "CARRERA", value: "carre", sortable: false },
        //{ text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersCantidadEstGrupo: [
        { text: "GRUPO", value: "idgru", sortable: true },
        { text: "PATERNO", value: "pat", sortable: true },
        { text: "MATERNO", value: "mat", sortable: true },
        { text: "NOMBRE", value: "nomb", sortable: true },
        { text: "ESTUDIANTES INSCRITOS", value: "cant", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGrupoInscripcion: [
        { text: "GRUPO", value: "gru", sortable: true },
        { text: "DOCENTE", value: "doce", sortable: true },
        { text: "NIVEL", value: "nivel", sortable: true },
        { text: "CUPO", value: "cup", sortable: true },
        { text: "MODALIDAD", value: "modalidad", sortable: true },
        { text: "TURNO", value: "tu", sortable: true },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGrupoInscripcionPracticos: [
        { text: "GRUPO", value: "gru", sortable: true },
        { text: "DOCENTE", value: "doce", sortable: true },
        { text: "NIVEL", value: "nivel", sortable: true },
        { text: "CUPO", value: "cup", sortable: true },
        { text: "MODALIDAD", value: "modalidad", sortable: true },
        { text: "TURNO", value: "tu", sortable: true },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGrupoPreInscripcion: [
        { text: "PARALELO", value: "gru", sortable: true },
        { text: "MATERIA", value: "mate", sortable: true },
        { text: "DOCENTE", value: "doce", sortable: true },
        { text: "NIVEL", value: "nivel", sortable: true },
        //{ text: "CUPO", value: "cup", sortable: true },
        { text: "MODALIDAD", value: "modalidad", sortable: true },
        { text: "TURNO", value: "tu", sortable: true },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersOfertaMaterias: [
        { text: "NIVEL", value: "idni", sortable: true },
        //{ text: "IDMATERIA", value: "idmat", sortable: true },
        { text: "CODIGO MATERIA", value: "codmat", sortable: true },
        { text: "MATERIA", value: "mat", sortable: true },
        //{ text: "CANT MAX", value: "cantmax", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGestion: [
        { text: "GESTION", value: "nom", sortable: false },
       // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersEstudiante: [
        { text: "UNICODIGO", value: "unicod", sortable: true },

        { text: "PATERNO", value: "pat", sortable: false },
        { text: "MATERNO", value: "mat", sortable: false },
        { text: "NOMBRES", value: "nom", sortable: false },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersKardex: [
        { text: "GESTION", value: "gest", sortable: true },
        { text: "MATERIA", value: "mate", sortable: true },
        { text: "1° P", value: "p1", sortable: true },
        { text: "2° P", value: "p2", sortable: false },
        { text: "3° P", value: "p3", sortable: true },
        { text: "EXM FINAL", value: "exfin", sortable: false },
        { text: "ASIST", value: "asis", sortable: true },
        { text: "2° INST", value: "seginst", sortable: true },
        { text: "MESA", value: "mesa", sortable: false },
        { text: "GRACIA", value: "graci", sortable: true },
        { text: "NOTA FINAL", value: "notafin", sortable: true },
        { text: "ESTADO", value: "estado", sortable: false },
        { text: "OBSERVACIONES", value: "observac", sortable: true },
      ],

      user: {},
      usuario: "",
      id_sede: "",
      nomus: "",
      patus: "",
      matus: "",
      id_documento: "",
      datosTipoDocumento: "",

      id_tipo_documento: "",
      tipo_doc_nom: "",
      iddocseg2: "",
      documento2: "",
      nivelMinimo: "",

      select: "",
      selectAño: "",
      selectCiudad: "",
      selectPais: "",
      tituloObtenido: "",
      institucion: "",
      areaEstudios: null,
      añoObtencion: "",
      cargaHoraria: null,
      datosPais: [],
      datosCiudad: [],
      tpFormacion: "",
      datosFormacionAcademica: [],
      selectPais1: "",
      act: 0,
      idForm: "",
      botonAct: 0,

      flag: 1,
    };
  },
  created: function () {
    this.user = JSON.parse(sessionStorage.getItem("session"));
    this.usuario = this.user.personal;
    this.id_sede = this.user.id_sede;
    this.nombreCompleto =
      this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
    this.paterno = this.user.paterno;
    this.materno = this.user.materno;
    this.nombres = this.user.nombres;
    this.unicodigo = this.user.unico;
  },
  computed: {},
  components: {
    VueHtml2pdf,
  },

  methods: {
    seleccionarCarrera(item) {
      this.carrera = item.carre;
      this.idCarrera = item.idcar;
      this.idPlanestudio = item.idplan;
      this.carreraModal = false;
     
    },
    async listarCarrera(unicodigo) {
      let me = this;
      await axios
        .get("/estudiante/listarcarreraestu/" + this.unicodigo + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCarrera = [];
          } else {
            me.datosCarrera = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },
    showGestion() {
      //this.limpiar();
      this.gestionModal = true;
      this.listarGestion();
    },
    closeGestion() {
      this.gestionModal = false;
    },
    showCarrera() {
      this.carreraModal = true;
      this.listarCarrera(this.unicodigo);
    },
    closeCarrera() {
      this.carreraModal = false;
    },
    seleccionarGestion(item) {
      this.gestion = item.nom;
      this.idGestion = item.id_gestion;
      this.gestionModal = false;
      this.listarHorario(this.unicodigo, this.idGestion, this.idPlanestudio);
      this.listarFranjaHoraria(this.unicodigo);
    },
    async listarGestion() {
      let me = this;
      await axios
        .get("/estudiante/buscagestionactualinscr/")
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGestion = [];
          } else {
            me.datosGestion = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },
    imprimirHorario() {
      this.$refs.html2Pdf.generatePdf();
    },

    getColor(insc) {
      if (insc == "LIBRE") return "green";
      else return "#868582";
    },
    getColorKardex(insc) {
      if (insc == "APROBADO") return "green";
      else return "red";
    },
    getColorGrupos(insc) {
      if (insc == "TEORICO") return "light-blue accent-2";
      else return "orange accent-2";
    },
    async listarTurno() {
      let me = this;
      await axios
        .get(
          "/estudiante/listarTurnoIns/" +
            this.idGestion +
            "," +
            this.idPlanestudio +
            "," +
            this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosTurno = [];
          } else {
            me.datosTurno = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },

    async listarFranjaHoraria(id_estudiante) {
      let me = this;
      await axios
        .get("/estudiante/listarFranjaHorariaEstCompartido/" + this.unicodigo+
            "," +
            this.id_sede )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosFranjaHoraria = [];
          } else {
            me.datosFranjaHoraria = response.data.resultado;
            me.datosFranjaHoraria.forEach(function (dato) {
              let dd = " ";
              dato.lu = dd;
              dato.ma = dd;
              dato.mi = dd;
              dato.ju = dd;
              dato.vi = dd;
              dato.sa = dd;
              dato.do = dd;
            });
            for (let i = 0; i < me.datosFranjaHoraria.length; i++) {
              for (let j = 0; j < me.datosHorario.length; j++) {
                if (
                  me.datosFranjaHoraria[i].idfh == me.datosHorario[j].idfranja
                ) {
                  switch (me.datosHorario[j].dias) {
                    case "LUNES":
                      me.datosFranjaHoraria[i].lu = me.datosHorario[j].docaumat;
                      break;
                    case "MARTES":
                      me.datosFranjaHoraria[i].ma = me.datosHorario[j].docaumat;
                      break;
                    case "MIERCOLES":
                      me.datosFranjaHoraria[i].mi = me.datosHorario[j].docaumat;
                      break;
                    case "JUEVES":
                      me.datosFranjaHoraria[i].ju = me.datosHorario[j].docaumat;
                      break;
                    case "VIERNES":
                      me.datosFranjaHoraria[i].vi = me.datosHorario[j].docaumat;
                      break;
                    case "SABADO":
                      me.datosFranjaHoraria[i].sa = me.datosHorario[j].docaumat;
                      break;
                    case "DOMINGO":
                      me.datosFranjaHoraria[i].do = me.datosHorario[j].docaumat;
                      break;
                    default:
                  }
                }
              }
            }
          } //else
        })
        .catch(function (error) {});
    },
    async listarHorario(unicodigo, idGestion, idPlanestudio) {
      let me = this;
      await axios
        .get(
          "/estudiante/listarHorarioEstudiante/" +
            this.unicodigo +
            "," +
            this.idGestion +
            "," +
            this.idPlanestudio+
            "," +
            this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosHorario = [];
          } else {
            me.datosHorario = response.data.resultado;

            me.listarFranjaHoraria(me.id_estudiante);
          }
        })
        .catch(function (error) {});
    },

    async listarHorarioGrupoPrivado(idGrupoDocente) {
      let me = this;
      await axios
        .get("/estudiante/listarHorarioGrupo/" + this.idGrupoDocente +
            "," +
            this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosHorariosGrupo = [];
          } else {
            me.datosHorariosGrupo = response.data.resultado;

            me.compararHorarios();
          }
        })
        .catch(function (error) {});
    },
    async listarHorarioGrupoCompartido(idGrupoPadre) {
      let me = this;
      await axios
        .get("/estudiante/listarHorarioGrupo/" + this.idGrupoPadre+
            "," +
            this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosHorariosGrupo = [];
          } else {
            me.datosHorariosGrupo = response.data.resultado;

            me.compararHorarios();
          }
        })
        .catch(function (error) {});
    },

    verificarGrupoCompartido() {
      this.listarHorarioGrupoCompartido(this.idGrupoPadre);
    },
    verificarGrupoPrivado() {
      this.listarHorarioGrupoPrivado(this.idGrupoDocente);
    },
    verificado() {
      this.verificarEspacio();
      //this.inscribir();
      //this.listarFranjaHoraria(this.id_estudiante);
      this.verificarExisteMateriaPractica();
    },

    compararHorarios() {
      this.choquecant = 0;
      this.choqueHorario = 0;

      for (let i = 0; i < this.datosHorariosGrupo.length; i++) {
        for (let j = 0; j < this.datosHorario.length; j++) {
          if (
            this.datosHorario[j].iddi == this.datosHorariosGrupo[i].iddi &&
            this.datosHorario[j].idfranja == this.datosHorariosGrupo[i].idfh
          ) {
            this.choqueHorario = 1;
            this.choquecant = this.choquecant + this.choqueHorario;
          } else {
            this.choqueHorario = 0;
            this.choquecant = this.choquecant + this.choqueHorario;
          }
        }
      }
      //for

      if (this.choquecant == 0) {
        this.verificado();
      } else {
        this.snackbarError1 = true;
        //this.mensajeSnackbarHorario ;
      }
    },

    showHorario() {
      //this.limpiar();

      this.horarioModal = true;
      //this.listarCarrera(this.unicodigo);
    },
    closeHorario() {
      this.horarioModal = false;
    },

    verificarHorario() {
      this.verificarhorario(
        this.idFranjaHoraria,
        this.id_estudiante,
        this.idDia
      );
    },
    async verificarhorario(idFranjaHoraria, id_estudiante, idDia) {
      let me = this;
      await axios
        .get(
          "/estudiante/verificarhorario/" +
            this.idFranjaHoraria +
            "," +
            this.id_estudiante +
            "," +
            this.idDia
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            //NO me.verificarEspacio();
            //NO me.verificarPreinscipcionNota();
            // me.listarGruposPreInscripcion(me.idPlanestudio, me.id_sede, me.idGestion, me.idTurno, me.idTipoModalidad, me.id_estudiante);
            //me.listarOfertaMaterias(me.id_estudiante, me.idPlanestudio, me.idGestion);
          } else {
            me.snackbarError = true;
            me.mensajeSnackbar = response.data.message;
          }
        })
        .catch(function (error) {
          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;
        });
    },
  },
};
</script>
    
    